import React, { Component } from 'react';
import { LuBadgeInfo, LuEye, LuFileEdit, LuTrash2, LuEyeOff } from 'react-icons/lu';
import { Tooltip } from 'react-tooltip';
import Swal from 'sweetalert2';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { DeleteDesignationRes, DeleteDesignationTodo } from 'redux/slice/super-admin/master/designation/DeleteDesignation';

class DesignationAction extends Component {
    constructor(props) {
        super(props);
        this.edit = this.edit?.bind(this);
        this.del = this.del?.bind(this);
        this.del_res = this.del_res?.bind(this);
    }



    edit() {
        this.props.history.push('../superadmin/update-designation', { state: this.props.data });
        // const { navigate, data } = this.props;
        // navigate('../superadmin/update-department', { state: data });
    }

    del() {
        const { dispatch, data } = this.props;
        Swal.fire({
            title: "Department Delete",
            text: "Are You Sure Want To Delete This Designation?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#121136',
            cancelButtonColor: '#EF3D50',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Delete'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(DeleteDesignationTodo(data.id)).then(() => this.del_res());
            }
        });
    }

    del_res() {
        const { bool, setBool } = this.props;
        if (DeleteDesignationRes && DeleteDesignationRes.success) {
            setBool(!bool); 
            Swal.fire(
                "Designation",
                'Designation Deleted Successfully',
                'success'
            );
        } else {
            toast.error(DeleteDesignationRes && DeleteDesignationRes.message, { position: "bottom-right" });
        }
    }

    render() {
        return (
            <div>
                <LuFileEdit size={20} className='edit text-success ms-3'
                    onClick={this.edit}
                    data-tooltip-id='edit'
                    data-tooltip-content="Edit Designation!"
                    data-tooltip-place="bottom"
                />

                <LuTrash2 size={20} className='delete text-danger ms-3'
                    onClick={this.del}
                    data-tooltip-id='del'
                    data-tooltip-content="Delete Designation!"
                    data-tooltip-place="bottom"
                />

                <Tooltip id='edit' className='bg-success tooltip_msg' />
                <Tooltip id='del' className='bg-danger tooltip_msg' />
                <Tooltip id='details' className='bg-primary tooltip_msg' />
                <Tooltip id='active' className='bg-secondary tooltip_msg' />
                <Tooltip id='deactivate' className='bg-secondary tooltip_msg' />
            </div>
        );
    }
}

export default withRouter(connect()(DesignationAction));

